import { v4 } from 'uuid';

import { Note } from '../note-classes/note.class';
import { NoteType } from './shared.enums';
import { RecordData } from '../helpers-classes';
import { NoteData, NoteDataIn, NoteParams } from './types';

export const noteData = (contextEmail: string, params: NoteParams | null = null, dataIn: NoteDataIn = null): NoteData => {
	// const { noteMessage = '', artifactId = null } = params || {};
	let rd: RecordData<NoteDataIn> = null;

	if (dataIn === null) {
		rd = new RecordData<NoteDataIn>(params);
	} else {
		rd = new RecordData<NoteDataIn>(dataIn);
	}

	const record: NoteData = {
		id: rd.useNewOrPartial<string>('id', v4()),
		createdBy: rd.useNewOrDefault<string>('createdBy', contextEmail),
		createDate: rd.useNewOrDefault<string>('createDate', new Date().toISOString()),
		artifactId: rd.useNewOrDefault<string>('artifactId', null),
		message: rd.useNewOrDefault<string>('message', ''),
		type: rd.useNewOrDefault<NoteType>('type', NoteType.NA),
		parent: rd.useNewOrDefault<Note>('parent', null),
		deletedBy: rd.useNewOrDefault<string>('deletedBy', null),
		deleteDate: rd.useNewOrDefault<string>('deleteDate', null),
		currentUser: rd.useNew<string>('currentUser', contextEmail)
	};

	return record;
};
